(function () {
  function initAddonBox(box) {
    if (!box) return;

    // Remove if inside quick add drawer / modal
    if (
      box.closest("quick-add-drawer") ||
      box.closest('[role="dialog"][aria-modal="true"]')
    ) {
      box.remove();
      return;
    }

    const btn = box.querySelector("[data-direct-id]");
    if (!btn) return;

    btn.addEventListener("click", async () => {
      if (btn.disabled) return;

      const id = parseInt(btn.getAttribute("data-direct-id"), 10);
      if (!id) return;

      btn.disabled = true;

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: id,
            quantity: 1,
          }),
        });

        if (!res.ok) throw new Error("Add failed");

        // Refresh cart
        document.dispatchEvent(
          new CustomEvent("cart:refresh", { bubbles: true })
        );

        // Open cart drawer if available
        const toggle = document.querySelector(
          "[data-cart-toggle],[aria-controls='CartDrawer']"
        );

        if (toggle) toggle.click();
      } catch (e) {
        console.warn("Addon add-to-cart failed", e);
      } finally {
        setTimeout(() => {
          btn.disabled = false;
        }, 500);
      }
    });
  }

  function initAll() {
    document.querySelectorAll(".apao-box[data-ap-context='addon']").forEach(initAddonBox);
  }

  // Run when DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Support Shopify dynamic sections
  document.addEventListener("shopify:section:load", initAll);
})();